// extracted by mini-css-extract-plugin
module.exports = {"toggle-buttons":"styles_toggle-buttons__1d3Dj","btn":"styles_btn___763_","active":"styles_active__R_6Ym"};